import React from 'react';
import PropTypes from 'prop-types';
import BasicSearchForm from 'components/BasicSearchForm';
import LoginForm from '../LoginForm';
import MediaQuery from 'react-responsive';
import pattern from 'assets/images/pattern.jpg';
import SideNavLinks from './schema';
import './styles.css';

const SideMenuBg = {
  background: `url(${pattern}) repeat`,
};

const SideMenu = props => {
  const { toggled, toggleFunc, onFormSubmit } = props;
  return (
    <nav
      className={toggled ? 'side-menu side-menu--open' : 'side-menu'}
      style={SideMenuBg}
    >
      <div className="side-menu__container">
        <button className="side-menu__close-btn" onClick={toggleFunc} />
        <MediaQuery query="(max-width: 1199px)">
          <div className="side-menu__login-form">
            <LoginForm
              onFormSubmit={onFormSubmit}
              authError={props.authError}
            />
          </div>
        </MediaQuery>
        <div className="side-menu__search">
          <BasicSearchForm />
        </div>
        <ul className="side-menu__links">
          {SideNavLinks.map((item, index) => {
            return (
              <li
                className={
                  toggled
                    ? 'side-menu__links-item side-menu__links-item--animated'
                    : 'side-menu__links-item'
                }
                key={index}
              >
                <a href={item.link} className="side-menu__link">
                  {item.text}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

SideMenu.propTypes = {
  toggled: PropTypes.bool,
  toggleFunc: PropTypes.func,
};

export default SideMenu;
